// Fires a conversion event when a visitor clicks an appointment/booking CTA.
// Only does anything if the consent-gated tracking scripts have loaded.
export function trackBooking(source = "header") {
  try {
    if (window.gtag) {
      window.gtag("event", "book_appointment", { event_category: "conversion", source });
    }
    if (window.fbq) {
      window.fbq("track", "Lead", { content_name: "Termin vereinbaren", source });
    }
  } catch {
    /* tracking must never break the click */
  }
}
